import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-modal-terminos',
  templateUrl: './modal-terminos.component.html',
  styleUrl: './modal-terminos.component.scss',
})
export class ModalTerminosComponent {
  @ViewChild('modalTerminos') modalTerminos!: ElementRef;
  @Input() titulo: string = '';
  @Input() contenido: string = '';
  @Output() aceptarTerminosEmitter = new EventEmitter<boolean>();

  abrirCerrarModal() {
    this.modalTerminos.nativeElement.click();
  }

  onAceptar() {
    this.aceptarTerminosEmitter.emit(true);
    this.abrirCerrarModal();
  }

  onRechazar() {
    this.aceptarTerminosEmitter.emit(false);
    this.abrirCerrarModal();
  }
}
